import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../utils/localStorage";

import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Button } from "primereact/button";
import SuccessModal from "../SuccessModal";
import StoreMenu from "../StoreMenu";
import { addStoreExternalWarehouseChallan, updateStoreExternalWarehouseChallan } from "../../services/StoreExternalWarehouse/StoreExternalWarehouse";
import { Calendar } from "primereact/calendar";
import ButtonLink from "../../ButtonLink";

const StoreExternalWarehouseChallanAdd = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {item, duplicate} = location.state || {}; // Fallback to prevent undefined errors

  const [visible, setVisible] = useState(false);

  const {storeData } = getUserData();
  const storeId = storeData.id;

  const [isUpdating, setIsUpdating] = useState(item);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [isButtonPressed, setIsButtonPressed] = useState(false);

  const [input, setInput] = useState({
    challanTo :"", // number only
    driverDetail :"",
    vehicleDetail :"",
    otherInfo :"",
    challanNumber :"", // number only
  });


  const [date, setDate] = useState(new Date());

  const maximumDate = new Date();
  maximumDate.setMonth(maximumDate.getMonth() + 1000); // Add 3 months to current date


  const minimumDate = new Date();


  useEffect(() => {
    setInput(prevState => ({
      ...prevState,
      challanNumber:
        isUpdating?.challanNumber && duplicate
          ? ''
          : isUpdating?.challanNumber, // number only
      challanTo: isUpdating?.challanTo || '',
      driverDetail: isUpdating?.driverDetail || '',
      vehicleDetail: isUpdating?.vehicleDetail || '',
      otherInfo: isUpdating?.otherInfo || '',
    }));
    let newDate = isUpdating?.createdDate ? new Date(isUpdating?.createdDate) : new Date();
    setDate(newDate);
   
  }, [isUpdating]);

  const [challanNumberError, setChallanNumberError] = useState('');
  const [driverDetailError, setDriverDetailError] = useState('');
  const [vehicleDetailError, setVehicleDetailError] = useState('');
  const [challanToError, setChallanToError] = useState("")
 
  const [otherInfoError, setOtherInfoError] = useState('');

  const handleSubmit = () => {
    // Reset all previous errors


    setChallanNumberError('');
    setChallanToError('');
    setDriverDetailError('');
    setVehicleDetailError('');
    setOtherInfoError('');


    let isValid = true;
    if (!input.challanNumber) {
      setChallanNumberError('Challan Number is Required');
      isValid = false;
    }
    if (!input.challanTo) {
      setChallanToError('Challan To is Required');
      isValid = false;
    }
    if (!input.driverDetail) {
      setDriverDetailError('Driver Detail is Required');
      isValid = false;
    }
    if (!input.vehicleDetail) {
      setVehicleDetailError('Vehicle Detail is Required');
      isValid = false;
    }
    if (!input.otherInfo) {
      setOtherInfoError('Other Info is Required');
      isValid = false;
    }
   
 


    if (isValid) {
      // Logic for creating a new pickup request
      if (!isButtonPressed) {
          // Set the state to indicate that the button has been pressed
          setIsButtonPressed(true);


        const data = {
          ...input,
          storeId: storeId,
          status:"create",
          createdDate:date
        };


        const UpdateData = {
          ...input,
          storeId: storeId,
          id: isUpdating?.id,
          status: 'create',
          createdDate: date,
        };

        // Call the service function for creating pickup request


        if (!isUpdating?.id) {
          addStoreExternalWarehouseChallan(data)
            .then(response => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.status;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus('success');
                    setModalText(message);
                    setTimeout(() => {
                      navigate('/StoreExternalWarehouseChallan');
                    }, 1500);
                    setIsButtonPressed(false);
                  } else {
                    setModalVisible(true);
                    setModalStatus('not Success');
                    setModalText(message);
                    setIsButtonPressed(false);
                  }
                }
              }
            })
            .catch(err => {
              console.error('Error:', err);
            });
        } else if(duplicate) {
          addStoreExternalWarehouseChallan(data)
            .then(response => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.status;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus('success');
                    setModalText(message);
                    setTimeout(() => {
                      navigate('/StoreExternalWarehouseChallan');
                    }, 1500);
                    setIsButtonPressed(false);
                  } else {
                    setModalVisible(true);
                    setModalStatus('not Success');
                    setModalText(message);
                    setIsButtonPressed(false);
                  }
                }
              }
            })
            .catch(err => {
              console.error('Error:', err);
            });
        } else {
            updateStoreExternalWarehouseChallan(UpdateData)
              .then(response => {
                if (!response.data.error) {
                  const Res = response.data;
                  if (Res) {
                    const message = Res.message;
                    const status = Res.status;
                    // sendResponse({message, status, modalFun: false});
                    // Reset state variables
                    if (status === true) {
                      setModalVisible(true);
                      setModalStatus('success');
                      setModalText(message);
                      setTimeout(() => {
                        navigate('/StoreExternalWarehouseChallan');
                      }, 1500);
                      setIsButtonPressed(false);
                    } else {
                      setModalVisible(true);
                      setModalStatus('not Success');
                      setModalText(message);
                      setIsButtonPressed(false);
                    }
                  }
                }
              })
              .catch(err => {
                console.error('Error:', err);
              });
        }
      }
    } else {
       setIsButtonPressed(false);
    }
  };

  return (
    <div className="flex-1" style={{ backgroundColor: "#FAF9F6" }}>
      <div
        className="h-3rem surface-0 sticky z-2 mb-3 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/StoreExternalWarehouseChallan")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
              {isUpdating?.id && duplicate ? 'Create' : isUpdating?.id ? 'Edit' : 'Create'} Challan
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4 flex-1">
          <FloatLabel>
            <InputText
              id="challanNumber"
              value={input.challanNumber}
              onChange={(e) => {
                setInput({
                  ...input,
                  challanNumber: e.target.value,
                });
                setChallanNumberError("");
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            {challanNumberError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {challanNumberError}
              </p>
            )}

            <label
              htmlFor="challanNumber"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Challan Number <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>

        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="challanTo"
              value={input.challanTo}
              onChange={(e) => {
                setInput({
                  ...input,
                  challanTo: e.target.value,
                });
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            {challanToError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {challanToError}
              </p>
            )}

            <label
              htmlFor="challanTo"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Challan To <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
      </div>
      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="driverDetail"
              value={input.driverDetail}
              onChange={(e) => {
                setInput({
                  ...input,
                  driverDetail: e.target.value,
                });
                  setDriverDetailError("");                
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            {driverDetailError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {driverDetailError}
              </p>
            )}

            <label
              htmlFor="driverDetail"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Driver Detail <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>

        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="vehicleDetail"
              value={input.vehicleDetail}
              onChange={(e) => {
                setInput({
                  ...input,
                  vehicleDetail: e.target.value,
                });
                  setVehicleDetailError("");                
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            {vehicleDetailError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {vehicleDetailError}
              </p>
            )}

            <label
              htmlFor="vehicleDetail"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Vehicle Detail <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
      </div>
      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="otherInfo"
              value={input.otherInfo}
              onChange={(e) => {
                
                  setInput({
                    ...input,
                    otherInfo: e.target.value,
                  });
                  setOtherInfoError("")
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />

            {otherInfoError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {otherInfoError}
              </p>
            )}
            <label
              htmlFor="otherInfo"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Other Info <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>   
        <div className="mx-4 mt-4  flex-1">
            <FloatLabel>
              <Calendar
                id="ValidToDatePicker"
                value={date}
                onChange={(e) => {
                setDate(e.target.value)}}
                showIcon
                minDate={minimumDate} 
                maxDate={maximumDate}
                className="w-full  bg-white-alpha-20 border-round-lg p-1 text-lg text-primary-50"
                dateFormat="dd/mm/yy"
              />
              <label
                htmlFor="ValidToDatePicker"
                className="text-md"
                style={{ color: "blue" }}
              >
                Date <span style={{ color: "red" }}>*</span>
              </label>
            </FloatLabel>
          </div>      
      </div>
       
      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />

      <div className="flex ">
        <Button
          className="mt-1 mb-3 mx-4 border-round-xl w-full"
          onClick={handleSubmit}
          disabled={isButtonPressed}
        >
          <p className=" w-full text-2xl font-semibold flex justify-content-center">
            Submit
          </p>
        </Button>
      </div>

      <StoreMenu setVisible={setVisible} visible={visible} />
      <ButtonLink />
    </div>
  );
};

export default StoreExternalWarehouseChallanAdd;
